<template>
    <div>
        <div class="row no-gutters" id="hero">
            <h1
                class="ml-3 text-light"
                style="position: absolute; bottom: 2rem; left: 2rem;"
            >
                Company
            </h1>
        </div>
        <div class="row no-gutters">
            <div
                class="p-3 p-sm-5 text-light col-lg-6 d-flex flex-column justify-content-center"
                style="background: #222;"
            >
                <div
                    class="logo-container d-flex flex-column align-items-center p-2 justify-content-center"
                >
                    <b-img
                        src="/images/west-chester-logo.svg"
                        style="max-width: 300px;"
                    ></b-img>
                    <h2 class="mt-4 text-center">
                        Who We Are
                    </h2>
                </div>
            </div>
            <div
                class="p-3 p-sm-5 text-light col-lg-6"
                style="background: #222;"
            >
                <p class=" p-3">
                    West Chester Protective Gear is a leader in merchandising
                    solutions. We are a global solution provider offering vast
                    experience partnered with continuing innovation and
                    cutting-edge capabilities. We're here to help you sell more
                    with our specialty services in private label solutions,
                    e-commerce support, and custom retail solutions .
                </p>
                <p class="p-3">
                    West Chester Protective Gear delivers personal protection
                    solutions that improve the performance and safety of workers
                    on the job and at home. As a trusted leader in the retail
                    channel, we develop and market high-performance gloves,
                    personal protective equipment (PPE), workwear and rainwear
                    through our leading brands – Boss®, Safety Works®, HEAROS®,
                    Mud® and West County Gardner®, as well as offer a portfolio
                    of well-known licensed products such as John Deere,
                    Scotts-MiracleGro, and CAT that complement our core lines.
                </p>
                <p class="p-3">
                    Customers depend on West Chester Protective Gear as a
                    trusted partner for branded, direct import and private label
                    solutions. As a global provider offering vast experience and
                    continuing innovation in product design, sourcing and
                    logistics, West Chester consistently delivers the right
                    products at the right value. One of the largest glove
                    manufacturers in the Western hemisphere, West Chester
                    Protective Gear is passionately committed to providing
                    outstanding service, quality, innovation and value.
                </p>
            </div>
        </div>
        <div class="row no-gutters">
            <div class="col-12">
                <div id="read-more" class="row no-gutters">
                    <div
                        id="private-label-container"
                        class="col-md-4 text-light d-flex flex-column justify-content-center flip-card"
                    >
                        <div
                            class="text-container p-5 flip-card-inner"
                            @click="flipCard"
                        >
                            <div class="flip-card-front">
                                <h3>PRIVATE LABEL SOLUTIONS</h3>
                                <p>
                                    Leading distributors and manufacturers
                                    depend on West Chester private label
                                    programs to extend their offerings and add
                                    value to their customers.
                                </p>
                            </div>
                            <div class="flip-card-back">
                                <h2>Private Label Solutions</h2>
                                <p>
                                    Leading distributors and manufacturers
                                    depend on West Chester private label
                                    programs to extend their offerings and add
                                    value to their customers.
                                </p>
                                <p>
                                    Our expertise and capabilities in product
                                    development, procurement, logistics, and
                                    technology make line extensions feasible and
                                    cost-effective for our customers.
                                </p>
                                <p>
                                    West Chester’s private label program gives
                                    customers significant advantages:
                                </p>
                                <ul>
                                    <li>
                                        Doing business with an experienced and
                                        trusted global supplier
                                    </li>
                                    <li>Low minimum order quantities</li>
                                    <li>Fast turn times</li>
                                    <li>
                                        An affordable way to expand your product
                                        line
                                    </li>
                                </ul>
                                <p>
                                    West Chester’s operating philosophy is built
                                    on service, quality, innovation, and value.
                                    We grow our business by growing yours.
                                    Contact us today to learn how a private
                                    label program can drive revenues and provide
                                    a competitive advantage.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        id="ecommerce-support-container"
                        class="col-md-4 text-light d-flex flex-column justify-content-center flip-card"
                    >
                        <div
                            class="text-container p-5 flip-card-inner"
                            @click="flipCard"
                        >
                            <div class="flip-card-front">
                                <h3>E-COMMERCE SUPPORT</h3>
                                <p>
                                    Our graphic specialists create stunning
                                    product shots from every angle imaginable,
                                    making products stick out instead of just
                                    blending in.
                                </p>
                            </div>
                            <div class="flip-card-back">
                                <h2>E-Commerce Support</h2>
                                <p>
                                    West Chester Protective Gear has lead the
                                    charge in the evolution of e-commerce. We
                                    work with our clients to create beautiful
                                    customer experiences across a broad array of
                                    online go to market solutions.
                                </p>
                                <p>
                                    Our team specializes in product photography.
                                    Using our cutting edge, in-house photography
                                    lab we are able to go above and beyond what
                                    your competitors are doing. With 360 degree
                                    photos and interactive media, we are able to
                                    guide the customer through the purchase
                                    funnel. We help them every step of the way
                                    until they are ready to checkout.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        id="custom-retail-container"
                        class="col-md-4 text-light d-flex flex-column justify-content-center flip-card"
                    >
                        <div
                            class="text-container p-5 flip-card-inner"
                            @click="flipCard"
                        >
                            <div class="flip-card-front">
                                <h3>CUSTOM RETAIL SOLUTIONS</h3>
                                <p>
                                    Our team has decades of experience creating
                                    custom designed solutions for every
                                    retailer, big and small.
                                </p>
                            </div>
                            <div class="flip-card-back">
                                <h2>Custom Retail Solutions</h2>
                                <p>
                                    West Chester Protective Gear is a global
                                    solution provider with a rich heritage in
                                    sourcing and logistics. We receive thousands
                                    of inbound containers every year with
                                    hundreds of direct imports for customers.
                                </p>
                                <p>
                                    West Chester partners with manufacturers in
                                    12 countries to deliver the best products to
                                    the market with on-time delivery and
                                    consistent quality. We also have a
                                    Representative Office in Shenzhen, China.
                                </p>
                                <p>
                                    Why do Industrial customers rely on West
                                    Chester’s global supply chain solutions?
                                </p>
                                <ul>
                                    <li>
                                        Managed supply chain delivery risk with
                                        primary, secondary, and third-tier
                                        factories
                                    </li>
                                    <li>
                                        Official presence in China with West
                                        Chester Shenzhen Representative Office
                                    </li>
                                    <li>
                                        Direct import capabilities-from the dock
                                        to your door
                                    </li>
                                    <li>
                                        VIP status with steam lines and freight
                                        forwarders
                                    </li>
                                    <li>
                                        Sophisticated sales and operational
                                        planning processes
                                    </li>
                                    <li>C-TPAT Tier II status</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-100 mt-1">
            <div class="row no-gutters">
                <div
                    id="brands"
                    class="col-12 d-flex flex-wrap justify-content-center"
                >
                    <div class="brands-content">
                        <div>
                            <h2 class="text-primary p-2 p-md-4 m-0 text-center">
                                Retail Brands
                            </h2>
                            <div class="brands-container">
                                <div class="brand" id="boss">
                                    <b-img
                                        src="/images/brand-logos/Logo-Boss-Red.png"
                                    ></b-img>
                                </div>
                                <div class="brand">
                                    <b-img
                                        src="/images/brand-logos/sw-logo.png"
                                        width="160"
                                    ></b-img>
                                </div>

                                <div class="brand">
                                    <b-img
                                        src="/images/brand-logos/mud-brown.png"
                                    ></b-img>
                                </div>

                                <div class="brand">
                                    <b-img
                                        src="/images/brand-logos/west-county-gardner.png"
                                    ></b-img>
                                </div>

                                <div class="brand">
                                    <b-img
                                        src="/images/brand-logos/hearos.png"
                                    ></b-img>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="divider"></div> -->
                    <div class="brands-content">
                        <div>
                            <h2 class="text-primary p-2 p-md-4 m-0 text-center">
                                Licensed Brands
                            </h2>
                            <div class="brands-container">
                                <div class="brand">
                                    <b-img
                                        src="/images/brand-logos/john-deere.png"
                                    ></b-img>
                                </div>
                                <div class="brand">
                                    <b-img
                                        src="/images/brand-logos/Scotts-200.png"
                                    ></b-img>
                                </div>
                                <div class="brand">
                                    <b-img
                                        src="/images/brand-logos/miracle-gro.png"
                                    ></b-img>
                                </div>

                                <div class="brand">
                                    <b-img
                                        src="/images/brand-logos/cat.png"
                                    ></b-img>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            literatures: [
                {
                    name: "Scott's Miracle-Gro Catalog",
                    path: "SMG-2018-Catalog-V5-lr.pdf",
                    image_path: "Scotts_MG_Catalog.jpg"
                },
                {
                    name: "West Chester Extreme Work Catalog",
                    path: "ExtremeWork_Retail_Catalog2017_V4_lr.pdf",
                    image_path: "ExtremeWork_Catalog.jpg"
                }
            ]
        };
    },
    methods: {
        flipCard() {
            $(this).css("transform", "rotateY(180deg)");
        }
    }
};
</script>

<style lang="scss">
.logo-container {
    h2 {
        font-size: 5rem;
        @media screen and (max-width: 844px) {
            font-size: 4rem;
        }
        @media screen and (max-width: 620px) {
            font-size: 3rem;
        }
    }
}

#hero {
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
        url("/images/WCPG_Building.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: right;
    border-bottom: 2px solid white;
    min-height: 30vh;
    position: relative;
    h1 {
        font-family: "Oswald", Helvetica, Arial, sans-serif;
        font-size: 3.5rem;
    }
}

.col-md-4 {
    min-height: 60vh;
    position: relative;
    background-size: cover;
    &:hover {
        .text-container {
            background: rgba(0, 0, 0, 0.8);
        }
    }
}

#private-label-container,
#ecommerce-support-container,
#custom-retail-container {
    position: relative;
    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-size: cover;
        filter: brightness(0.6);
    }
}

#private-label-container {
    &:before {
        background-image: url("/images/private-label-hero-bg.jpg");
    }
}

#ecommerce-support-container {
    &:before {
        background-image: url("/images/ecommerce-support-hero-bg.jpg");
    }
}

#custom-retail-container {
    &:before {
        background-image: url("/images/retail-custom-hero-bg.jpg");
    }
}
.text-container {
    transition: all 0.4s ease-out;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
    align-items: center;
    z-index: 10;
    button {
        max-width: 200px;
    }
}

.divider {
    width: 2px;
    border-right: 1px solid #ccc;
    @media screen and (max-width: 620px) {
        display: none;
    }
}
.brands-content {
    max-width: 50%;
    display: flex;
    justify-content: center;
    @media screen and (max-width: 620px) {
        max-width: 100%;
    }
    &:first-child {
        border-right: 1px solid #ebebeb;
    }
    &:last-child {
        border-left: 1px solid #ebebeb;
    }

    .brands-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        @media screen and (max-width: 1510px) {
            justify-content: center;
            margin-left: unset;
        }
        .brand {
            min-width: 50%;
            padding: 2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
                max-width: 100%;
                filter: grayscale(1);
                transition: filter 0.4s ease-out;
                &:hover {
                    filter: grayscale(0);
                }
            }
        }
        #boss {
            max-width: 12%;
        }
    }
}

.flip-card {
    perspective: 700px;
    @media screen and (max-width: 1420px) {
        min-width: 50%;
    }
    &:last-child {
        @media screen and (max-width: 1420px) {
            min-width: 100%;
            .flip-card-inner {
                max-width: 50%;
            }
        }
        @media screen and (max-width: 963px) {
            .flip-card-inner {
                max-width: 100%;
            }
        }
    }
    @media screen and (max-width: 963px) {
        min-width: 100%;
    }
    @media screen and (max-width: 490px) {
        min-height: 100vh;
    }
    .flip-card-inner {
        position: relative;
        width: 100%;
        height: 100%;
        transition: transform 0.8s;
        transform-style: preserve-3d;
        padding: 2rem;
    }
    &:hover .flip-card-inner {
        transform: rotateY(180deg);
    }
    .flip-card-front,
    .flip-card-back {
        position: absolute;
        width: 100%;
        height: 100%;
        backface-visibility: hidden;
        padding: 2rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        ul {
            margin-left: 2rem;
            margin-bottom: 2rem;
        }
        @media screen and (max-width: 963px) {
            max-width: 60%;
        }
        @media screen and (max-width: 832px) {
            max-width: 100%;
        }
    }
    .flip-card-back {
        transform: rotateY(180deg);
        font-size: 0.9rem;
    }
}
</style>
